export const footer = [
  {
    title: "USEFUL LINKS",
    Links: [
      {
        Name: "Help Center",
      },
      {
        Name: "Media Center",
      },
      {
        Name: "Jobs.",
      },
    ],
  },
  {
    title: "COMMUNITY",
    Links: [
      {
        Name: "Privacy",
      },
      {
        Name: "Gift Cards",
      },
      {
        Name: "Terms of Use.",
      },
    ],
  },
  {
    title: "PARTNERS",
    Links: [
      {
        Name: "Cookie Preference",
      },

      {
        Name: "Privacy",
      },

      {
        Name: "Contact Us.",
      },
    ],
  },
];
